import { BoxesCore } from './BackgroundBoxes';

function LandingScreen() {
  return (
    <div className='landingScreenContainer'>
      <BoxesCore />
      <div className='landingScreenAboutMeContainer'>
        <h2>Hello World</h2>
        <div className='landingScreenAboutMe'>
          <p>My name is Filip, and I am a self-taught Front-End Developer with over 1.5 years of experience. I focus on creating responsive, user-friendly websites using Wordpress, React JS, HTML, CSS, and JavaScript. I am passionate about learning new technologies, adapting quickly, and taking on new challenges.
          </p>
        </div>
      </div>
      <div className='landingScreenMyPhotoBox'>
        <div className='blueRoundBackground'>
          <div className='whiteRoundBackground'></div>
        </div>
        <div className='blueDashedLineCenterVertical' />
      </div>
      {/* <div className='landingScreenMainContent'></div> */}
      <div className='blueDashedLineCenterHorizontal' />
    </div>
  );
}

export default LandingScreen;
